// extracted by mini-css-extract-plugin
export var quillEditor = "_ob-1";
export var variable = "_ob-0";